import { cn } from '../../lib/cn';
import { Card, Badge } from '../ui';
import type { AlertItem, AlertCategory } from '../../rolexp/framework';

type Props = {
  alerts?: AlertItem[];
  className?: string;
};

const variantMap: Record<AlertCategory, 'error' | 'warning' | 'success' | 'info' | 'ai' | 'default'> = {
  critical: 'error',
  warning: 'warning',
  opportunity: 'success',
  information: 'info',
  ai_suggestion: 'ai',
  marketplace_event: 'info',
  team_mention: 'default',
};

export function AlertCenterWidget({ alerts = [], className }: Props) {
  return (
    <Card className={cn(className)} padding="sm">
      <p className="text-xs font-semibold uppercase tracking-wide text-slate-500">Alert Center</p>
      <ul className="mt-3 space-y-2">
        {alerts.map((a) => (
          <li key={a.id} className="rounded-md border border-slate-100 p-2 dark:border-slate-800">
            <div className="flex items-center gap-2">
              <Badge variant={variantMap[a.category]}>{a.category.replace(/_/g, ' ')}</Badge>
              {a.module && <span className="text-[10px] text-slate-400">{a.module}</span>}
            </div>
            <p className="mt-1 text-sm font-medium text-slate-900 dark:text-slate-100">{a.title}</p>
            {a.message && <p className="text-xs text-slate-500">{a.message}</p>}
          </li>
        ))}
      </ul>
    </Card>
  );
}
